import React from "react";
import {DocSearch}  from '@docsearch/react';

import '@docsearch/css';

function SearchAlgolia() {
    return (
        <DocSearch
            appId="RSET3XFTH5"
            indexName="mc-movielabs"
            apiKey="f6e597903d9650f50b8f78f034bcd9ea"
        />
    );
}

export default SearchAlgolia;